import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { header3, header5 } from 'styles/texts'
import { primary, primaryHovered, white, inputBackground } from 'styles/colors'

const LinkButton = styled(Link)`
  display: inline-block;
  ${props => (props.size === 'large' ? header3 : header5)};
  padding: ${props => (props.size === 'large' ? '10px 50px 11px' : '5px 20px')};
  background-color: ${props => (props.secondary ? white : primary)};
  border: ${props => (props.secondary ? 'solid 1px ' + primary : 'none')};
  border-radius: 5px;
  color: ${props => (props.secondary ? primary : white)};
  outline: none;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${props =>
      props.secondary ? inputBackground : primaryHovered};
    border: ${props =>
      props.secondary ? 'solid 1px ' + primaryHovered : 'none'};
    color: ${props =>
      props.secondary ? 'solid 1px ' + primaryHovered : white};
  }
  text-decoration: none;
`

const Button = styled.button`
  display: inline-block;
  width: ${props => (props.size === 'large' ? '186px' : '120px')};
  ${props => (props.size === 'large' ? header3 : header5)};
  padding: ${props => (props.size === 'large' ? '10px 20px' : '5px 10px')};
  background-color: ${props => (props.secondary ? white : primary)};
  border: ${props => (props.secondary ? 'solid 1px ' + primary : 'none')};
  border-radius: 5px;
  color: ${props => (props.secondary ? primary : white)};
  outline: none;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${props =>
      props.secondary ? inputBackground : primaryHovered};
    border: ${props =>
      props.secondary ? 'solid 1px ' + primaryHovered : 'none'};
    color: ${props =>
      props.secondary ? 'solid 1px ' + primaryHovered : white};
  }
`

export default props =>
  props.to ? <LinkButton {...props} /> : <Button {...props} />



// WEBPACK FOOTER //
// ./src/components/Button.js